import React, { useEffect, useState } from "react";
import styles from "./support.module.css";
import { useChat } from "../../context/chat-context";
import ChatDetails from "../communication/components/chat-details/chat-details";
import ChatSidebar from "../communication/components/chat-sidebar/chat-sidebar";

const Support = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const { selectedChat, setSelectedChat, setChatHistory, isSuperAdmin } = useChat();
  const roles = isSuperAdmin
    ? ['ADMIN', 'TEACHER', 'STUDENT', 'PARENT']
    : ['SUPER-ADMIN', 'TEACHER', 'STUDENT', 'PARENT'];
  const chatRules = {
    can_message: roles,
    can_see: roles,
  };

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => {
      setSelectedChat(null);
      setChatHistory([]);
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <div>
      <div className={styles["support-heading-wrapper"]}>
        <div className={styles["support-heading"]}>My Support</div>
      </div>

      {isSuperAdmin ? (
        <div>
          {isMobile ? (
            <div className={styles["support-all-chat-container"]}>
              {selectedChat ? (
                <ChatDetails 
                  selectedChat={selectedChat} 
                  setSelectedChat={setSelectedChat}
                  chatRules={chatRules}
                />
              ) : (
                <ChatSidebar 
                  selectedChat={selectedChat}
                  setSelectedChat={setSelectedChat}
                  chatRules={chatRules}
                />
              )}
            </div>
          ) : (
            <div className={styles["support-all-chat-container"]}>
              <ChatSidebar 
                selectedChat={selectedChat}
                setSelectedChat={setSelectedChat}
                chatRules={chatRules}
              />
              <div style={{ paddingLeft: "16px", width: "100%" }}>
                {selectedChat ? (
                  <ChatDetails 
                    selectedChat={selectedChat} 
                    setSelectedChat={setSelectedChat}
                    chatRules={chatRules}
                  />
                ) : (
                  <h2>Select a chat to view the conversation</h2>
                )}
              </div>
            </div>
          )}
        </div>
      ) : (
        <div className={styles["support-all-chat-container"]}>
          <div style={{ width: "100%" }}>
            {selectedChat ? (
              <ChatDetails 
                selectedChat={selectedChat} 
                setSelectedChat={setSelectedChat}
                chatRules={chatRules}
              />
            ) : (
              <h2>Loading...</h2>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default Support;
